import {Image} from 'react-native'

export const HighPriorityImage = Image
